import React from "react";
import { styled, TextField } from "@mui/material";

const CustomTextField = styled(TextField)(() => ({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "rgba(0, 0, 0, 0.46)",
    border: "1px solid #ffffff33",
    borderRadius: "12px",
    color: "white",
    // padding: "10px 15px",
    padding: "0",
    "&:hover": {
      //   backgroundColor: "transparent",
      border: "1px solid #ef364e",
    },
    "&.Mui-focused": {
      //   backgroundColor: "transparent",
      border: "1px solid #ef364e",
      outline: "none",
    },
  },

  "& .MuiInputBase-input": {
    // padding: "0",
    padding: "10px 15px",
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
    "&:hover": {
      border: "none",
    },
  },
}));

export default CustomTextField;
